var exports = {
  "Pc": "MemeFormFields.module__tagsContainer___NVh2aV",
  "Pr": "MemeFormFields.module__tagsHeader___NVh2aV",
  "ft": "MemeFormFields.module__tagsHeaderLabel___NVh2aV",
  "C_": "MemeFormFields.module__tagsInputRow___NVh2aV",
  "Cs": "MemeFormFields.module__tagsList___NVh2aV",
  "r3": "MemeFormFields.module__tagChip___NVh2aV",
  "xH": "MemeFormFields.module__tagRemoveButton___NVh2aV",
};

module.exports = exports;
